import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Row, Col, Form } from 'react-bootstrap';
import InlineInput from '../../../../../../src/web/components/form/inputs/InlineInput/InlineInput';
import styles from '../PopupFields/styles.scss';

const propTypes = {
  onControlChange: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  settingsTrigger: PropTypes.string.isRequired,
  settingsTimer: PropTypes.string.isRequired,
  settingsMobile: PropTypes.bool.isRequired,
  settingsLeadSource: PropTypes.string.isRequired,
  settingsNewLeadSource: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  errorCreatingLeadSource: PropTypes.string.isRequired,
};

const defaultProps = {};

const attrs = [
  'onControlChange',
  'onCheckboxChange',
  'settingsTrigger',
  'settingsTimer',
  'settingsMobile',
  'settingsLeadSource',
  'settingsNewLeadSource',
  'sources',
  'errorCreatingLeadSource',
];

const newLeadSourceOption = { name: 'Create new lead source' };

const SettingsFields = ({
  onControlChange,
  onCheckboxChange,
  settingsTrigger,
  settingsTimer,
  settingsMobile,
  settingsLeadSource,
  settingsNewLeadSource,
  errorCreatingLeadSource,
  sources,
}) => (
  <Row>
    <Col xs={12}>
      {errorCreatingLeadSource && <Alert variant="danger">{errorCreatingLeadSource}</Alert>}
      <Form.Group className={styles.FormGroup}>
        <label htmlFor="settingsTrigger">Pop-up Triggers</label>
        <Form.Check
          type="radio"
          // className={styles.radio}
          name="settingsTrigger"
          checked={settingsTrigger === 'scroll'}
          value="scroll"
          onChange={onControlChange}
          label="On 50% page scroll"
        />
        <Form.Check
          type="radio"
          className={styles.radio}
          name="settingsTrigger"
          checked={settingsTrigger === 'time'}
          value="time"
          onChange={onControlChange}
          label={(
              <InlineInput
                type="number"
                label="After"
                postText="second(s)"
                name="settingsTimer"
                onChange={onControlChange}
                value={settingsTimer}
                min={0}
                required
              />
)}
        />

      </Form.Group>
      <Form.Group className={styles.FormGroup}>
        <label htmlFor="settingsMobile">Mobile Settings</label>
        <Form.Check className={styles.radio} id="popUpCheck" type="checkbox" name="settingsMobile" onChange={onCheckboxChange} checked={settingsMobile} label="Turn off pop-up on mobile devices" />
      </Form.Group>
      <Form.Group className={styles.FormGroup}>
        <label htmlFor="settingsLeadSource">Choose a Lead Source</label>
        <Form.Control
          name="settingsLeadSource"
          as="select"
          onChange={onControlChange}
          value={settingsLeadSource}
        >
          <option value="-1" disabled>Select...</option>
          {[newLeadSourceOption, ...sources].map(({ name }) => (
            <option key={name} value={name}>{name}</option>
          ))}
        </Form.Control>
      </Form.Group>
      {settingsLeadSource === newLeadSourceOption.name
        && (
        <Form.Group validationState={errorCreatingLeadSource ? 'error' : null}>
          <label htmlFor="settingsNewLeadSource">New Lead Source Name</label>
          <Form.Control name="settingsNewLeadSource" onChange={onControlChange} value={settingsNewLeadSource} />
        </Form.Group>
        )
      }
      <Alert className={styles.alertInfo}>
        If this pop-up is placed on any page other than a facility page,
        a facility selector will also be present in order for the lead to
        be assigned to the correct facility.
      </Alert>
    </Col>
  </Row>
);

SettingsFields.propTypes = propTypes;
SettingsFields.defaultProps = defaultProps;
SettingsFields.attrs = attrs;

export default SettingsFields;
